import React, { ChangeEvent, FC, Fragment, useState } from 'react';
import { Box, FormControl, Grid, InputLabel, MenuItem, Select, SelectChangeEvent, TextField } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { CertifyListType, UnCertifiedOrderFilter } from 'models/order';

type CertifyOrdersPageActionsProps = {
    onFilterChange: (filters: UnCertifiedOrderFilter) => void;
};

const CertifyOrdersPageActions: FC<CertifyOrdersPageActionsProps> = ({
    onFilterChange,
}: CertifyOrdersPageActionsProps) => {
    const { t: translate } = useTranslation(['orders', 'common']);

    const [searchTimeout, setSearchTimeout] = useState<ReturnType<typeof setTimeout>>();
    const [listType, setListType] = useState(CertifyListType.MY_CERTIFICATIONS.toString());
    const [search, setSearch] = useState('');

    const handleTextChange = (event: ChangeEvent<HTMLInputElement>) => {
        const value = event.target.value;
        if (searchTimeout) {
            clearTimeout(searchTimeout);
        }
        const timeout = setTimeout(() => {
            if (value.length === 0 || value.length >= 2) {
                setSearch(value);
                onFilterChange({
                    search: value,
                    myCertifications: listType === CertifyListType.MY_CERTIFICATIONS,
                });
            }
        }, 300);
        setSearchTimeout(timeout);
    };

    const handleListTypeChange = (event: SelectChangeEvent) => {
        const listTypeValue = event.target.value;
        setListType(listTypeValue);
        onFilterChange({
            search,
            myCertifications: listTypeValue === CertifyListType.MY_CERTIFICATIONS,
        });
    };

    return (
        <Fragment>
            <Box mb={1} display="flex" alignItems="center">
                <Grid container spacing={1}>
                    <Grid item md={2} sm={6} xs={12}>
                        <FormControl fullWidth margin="dense">
                            <InputLabel id="certify-select">{translate('orders:CERTIFICATION')}</InputLabel>
                            <Select
                                value={listType}
                                onChange={handleListTypeChange}
                                labelId="clinic-select-label"
                                label={translate('orders:CERTIFICATION')}
                            >
                                <MenuItem value={CertifyListType.MY_CERTIFICATIONS.toString()}>
                                    {translate('orders:MY_CERTIFICATIONS')}
                                </MenuItem>
                                <MenuItem value={CertifyListType.ALL_CERTIFICATIONS.toString()}>
                                    {translate('orders:ALL_CERTIFICATIONS')}
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </Grid>
                    <Grid item sm={4} xs={12}>
                        <TextField
                            fullWidth
                            id="filter-name"
                            onChange={handleTextChange}
                            margin="dense"
                            name="search"
                            label={translate('orders:SEARCH_ORDERS')}
                        />
                    </Grid>
                </Grid>
            </Box>
        </Fragment>
    );
};

export default CertifyOrdersPageActions;
